<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - '+routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p
        class="mb-5 text-justify"
      >Ingresar número de código y rango de fechas que desea consultar.</p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-buscar="getGarantiaPagada"
        @click-event="clickEvent"
        filtro
        pagination
        showFilterDates
        showFilterConvenios
        :Convenios="convenios"
        :dataLength="dataLength"
        :perPage="perPage"
        :showExportToExcel="true"
      >
        <table-column  :customClass="'text-center'" slot="label" :label="'Cédula'" v-bind:value="'cedula'"></table-column>
        <table-column  slot="label" :label="'Cliente'" v-bind:value="'nombre'"></table-column>
        <table-column :customClass="'text-center'" slot="label" :label="'Pagaré'" v-bind:value="'pagare'"></table-column>
        <table-column :customClass="'text-center'" slot="label" :label="'modelo'" v-bind:value="'modelo'"></table-column>
        <table-column :customClass="'text-center'" slot="label" :label="'Código'" v-bind:value="'convenio'"></table-column>
        <table-column
          slot="label"
          :label="'Total Pagado'"
          v-bind:value="'total_pago'"
          :filter="'numberFormat'"
          :customClass="'text-center'"
        ></table-column>
        <table-column :customClass="'text-center'" slot="label" :label="'Fecha Pago'" v-bind:value="'fecha_pago'"></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      perPage: 10,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      loading: "loading",
    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "Código", disabled: true });
      return data;
    },
    dataLength() {
      return this.$store.getters["pages/dataInformes"].paginacion.total;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 10000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let response = await this.$store.state.api.get(
              "informes/garantia_pagada",
              {
                params: {
                  paginar: "false",
                  fecha_inicio: this.$store.getters["table/dateInicio"],
                  fecha_fin: this.$store.getters["table/dateFin"],
                  convenio: this.$store.getters["table/filterConvenioSelected"]
                },
              }
            );
            console.log(response)
            let datos = XLSX.utils.json_to_sheet(response.data.datos,  {
              header: [
                "cedula",
                "nombre",
                "pagare",
                "convenio",
                "saldo_capital",
                "intereses",
                "otgast_liq",
                "total_pago",
                "fecha_pago",
                "modelo"
              ],
            });
            datos["A1"].v = "cedula";
            datos["B1"].v = "Nombre";
            datos["C1"].v = "pagare";
            datos["D1"].v = "Código";
            datos["E1"].v = "saldo capital";
            datos["F1"].v = "Intereses";
            datos["G1"].v = "Otros gastos";
            datos["H1"].v = "Total pago";
            datos["I1"].v = "Fecha pago";
            datos["J1"].v = "modelo";
            //
            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, datos, "Coberturas Pagadas");
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "OperacionesPagadas.xlsx"
            );

            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    getGarantiaPagada(params) {
      this.fecha_inicio = params.fecha_inicio;
      this.fecha_fin = params.fecha_fin;
      this.convenio = params.convenio;
      this.perPage = params.nRows;
      this.loadData();
    },
    loadData(row, page, paginar = true) {
      this.$store.dispatch("pages/fetch", {
        endpoint: "informes/garantia_pagada",
        params: {
          row: this.perPage,
          page: page ? page : 1,
          paginar: paginar,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          convenio: this.convenio,
        },
      });
    },
  },

  mounted() {
    if (this.$store.getters["pages/convenios"].length < 1) {
      this.$store.dispatch("pages/fetchConvenios", {
        endpoint: "informes/convenio",
      });
    }
  },
};
</script>